import React from 'react';
import { Container, FlexGrid, Anchor } from '@honeycomb/ui-core';
import { useGenericRootComponent } from './GenericRootComponent/GenericRootComponent.context';
export function InlineLinkGroup({ linkGroup: { links, contentId } }) {
    const { textColor } = useGenericRootComponent();
    return (React.createElement(Container, { component: "section" },
        React.createElement(FlexGrid, { container: true, spacing: 6, justifyContent: "center", flexDirection: "row" }, links.map((link, index) => {
            var _a;
            const key = `${contentId}-${index}`;
            return (React.createElement(FlexGrid, { key: key },
                React.createElement(Anchor, { size: "s", href: (_a = link.url) !== null && _a !== void 0 ? _a : '#', weight: "semiBold", color: textColor !== null && textColor !== void 0 ? textColor : 'text.link' }, link.text)));
        }))));
}
